import React, { useState } from "react";
import { CRMView } from "@/components/CRMView";
import { LeadsPanel } from "@/components/LeadsPanel";
import { CRMStatsPanel } from "@/components/CRMStatsPanel";
import { ConversationAssistant } from "@/components/ConversationAssistant";
import { LeadImportPanel } from "@/components/LeadImportPanel";
import { CRMEmailSettingsPanel } from "@/components/CRMEmailSettingsPanel";
import { CRMInboxPanel } from "@/components/CRMInboxPanel";
import { WhatsAppInboxPanel } from "@/components/WhatsAppInboxPanel";
import { CRMRecycleBinPanel } from "@/components/CRMRecycleBinPanel";

export function CRMTab({ company, onCreateQuoteFromDeal, onOpenQuote, hasFeature = () => true }) {
  const [view, setView] = useState("pipeline");
  const btn = (id, label, testid) => (
    <button
      onClick={() => setView(id)}
      data-testid={testid}
      className={`px-4 py-1.5 rounded-md text-sm font-medium transition ${
        view === id ? "bg-[var(--brand-primary)] text-white" : "text-[var(--brand-muted)] hover:text-[var(--brand-ink)]"
      }`}
    >
      {label}
    </button>
  );
  return (
    <div>
      <div className="inline-flex flex-wrap rounded-lg border border-[var(--brand-border)] bg-white p-1 mb-4" data-testid="crm-subtabs">
        {btn("pipeline", "Pipeline", "crm-subtab-pipeline")}
        {btn("leads", "Leads", "crm-subtab-leads")}
        {btn("import", "Import", "crm-subtab-import")}
        {btn("inbox", "Inbox", "crm-subtab-inbox")}
        {btn("email", "E-Mail", "crm-subtab-email")}
        {btn("whatsapp", "WhatsApp", "crm-subtab-whatsapp")}
        {btn("conversation", "Gesprächsassistent", "crm-subtab-conversation")}
        {btn("recycle-bin", "Papierkorb", "crm-subtab-recycle-bin")}
        {hasFeature("crm_premium") && btn("stats", "Statistik", "crm-subtab-stats")}
      </div>
      {view === "pipeline" && <CRMView company={company} onCreateQuoteFromDeal={onCreateQuoteFromDeal} />}
      {view === "leads" && <LeadsPanel />}
      {view === "import" && <LeadImportPanel />}
      {view === "inbox" && <CRMInboxPanel />}
      {view === "email" && <CRMEmailSettingsPanel />}
      {view === "whatsapp" && <WhatsAppInboxPanel />}
      {view === "conversation" && <ConversationAssistant onOpenQuote={onOpenQuote} />}
      {view === "recycle-bin" && <CRMRecycleBinPanel />}
      {view === "stats" && hasFeature("crm_premium") && <CRMStatsPanel />}
    </div>
  );
}
